import { Link } from 'react-router-dom';
import { LoginForm } from '../features/auth/components/LoginForm';
import { useBrandTheme } from '../components/providers/brand-theme-provider.utils';

export const LoginPage = () => {
  const { brandName } = useBrandTheme();
  return (
    <div className='flex min-h-screen flex-1 flex-col justify-center px-6 py-12 lg:px-8 bg-background'>
      <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
        <h2 className='mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-foreground'>
          Inicia sesión en {brandName}
        </h2>
      </div>

      <div className='mt-10 sm:mx-auto sm:w-full sm:max-w-sm bg-card text-card-foreground px-6 py-8 shadow-sm rounded-lg border'>
        <LoginForm />
        <div className='mt-5 text-center'>
          <Link className='text-sm underline' to='/forgot-password'>
            ¿Olvidaste tu contraseña?
          </Link>
        </div>
      </div>
    </div>
  );
};
